<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { FrameIcon } from "lucide-vue-next";
import { useSuggestionContext } from "../suggestions";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";
import { useDocumentCommandContext } from "./context";

const props = defineProps<CommandItemBaseProps>();

const { isBrowseSections } = useDocumentCommandContext();
const { reset } = useSuggestionContext();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange({
      from: props.range.from + 1,
      to: props.range.to,
    })
    .run();
  reset();
  isBrowseSections.value = true;
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="FrameIcon"
    @click="run"
    @keydown.enter="run"
  >
    Section link
  </SuggestionListItem>
</template>
